import HertzCar, { Id, Seats, Insurance } from '@/classes/Hertz/HertzCar'
import { isNumber } from 'typechecker'

export type HertzPricedCarArgument = {
  id?: Id | null
  currency?: string
  price?: number
  originalPrice?: number
  model?: string
  type?: string
  transmission?: string
  doors?: number
  exhaust?: number | null
  features?: string[]
  insurances?: Insurance[]
  isDomestic?: boolean
  images?: string[]
  seats?: Seats
  SIPP?: string
  airCondition?: string
  fuelType?: string
  mileagePolicy?: object
}

/** 附有價格資訊的車輛 */
export default class HertzPricedCar extends HertzCar {
  /** 實際價格 */
  price: number
  /** 僅供促銷顯示用的「原價」 */
  originalPrice?: number

  constructor (car: HertzPricedCarArgument) {
    super(car)

    if (isNumber(car.price)) {
      this.price = car.price!
    } else throw new TypeError('Invalid `price` object!')

    if (car.originalPrice) {
      this.originalPrice = car.originalPrice
    }
  }
}
